import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavBarTop = ({ title, right }) => {
  const navigate = useNavigate();
  return (
    <nav className="navbar navbar-expand bg-white navbar-modern sticky-top shadow-sm py-2">
      <div className="container-fluid px-3">
        <div className="d-flex align-items-center w-100 justify-content-between">
          <div className="d-flex align-items-center">
            <button className="btn btn-link p-0 me-2" style={{fontSize: '1.5rem'}} onClick={() => navigate(-1)}>
              <i className="bi bi-arrow-left"></i>
            </button>
            <h4 className="fw-bold mb-0 text-dark" style={{letterSpacing: 0.5, fontSize: '1.15rem'}}>{title}</h4>
          </div>
          {right && <div>{right}</div>}
        </div>
      </div>
    </nav>
  );
};

export default NavBarTop;
